<template>
  <header class="header_comp">
    <!-- <div v-if="headerClickShow&&name=='/home'" class="click_for_deails">
      Ready For The New Version of ANTDIY !
      <a href="https://www.antlinksgroup.com/detail?p=1634" rel="nofollow" title="A Step-by-Step Guide to Starting A New ANTDIY">Click Here For Details</a>
    </div> -->
    <div class="fix_height">
      <div :class="name === '/home' ? 'header' : 'header header_black'">
        <div class="header_box">
          <img :src="name === '/home' ? './static/imgs/logo.svg' : '../../../static/imgs/logo_white.svg'" @click="changeRouter('/home')" rel="Dropshipping Business" title="Dropshipping Business"/>
          <div class="logo_right_text" v-if="name === '/allapps'">All apps</div>
          <div class="logo_right_text" v-if="name === '/help' || name === '/help/detail'">Help center</div>
          <div class="header_page">
            <!--  -->
            <span v-for="item in pageList" :key="item.name" :class="name === '/home' ? 'header_text' : 'header_text header_text_white'" @click="changeRouter(item.link)"
              @mouseover="item.name == 'Products' ? dropBoxOut() : null"
              @mouseleave="item.name == 'Products' ? dropBoxIn() : null">
              {{item.name}}
              <img src="../../assets/pull_down.svg" v-if="item.tab==true">
            </span>
            <div :class="nameList.indexOf(linkName) > -1 ? `active active${nameList.indexOf(linkName)}` : 'active active-1'">
            </div>
            <div class="drop_down_box" @mouseover="dropBoxOut()" @mouseleave="dropBoxIn()">
              <div class="drop_box" v-if="dropBoxValue">
                <div class="drop_box_1" @click="dropBoxIn();changeRouter('/antdiy')">ANTDIY</div>
                <div class="drop_box_2" @click="dropBoxIn();changeRouter('/antsupply')">ANTSUPPLY</div>
              </div>
            </div>
          </div>
          <!-- <A-Button text='Free trial' @onclick="goLink(`/home`)"></A-Button> -->
          <A-Button text='Free trial' @onclick="goLink(`https://apps.shopify.com/salesdish`)"></A-Button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['name', 'headerClickShow'],
  data () {
    return {
      pageList: [
        { name: 'Home', link: '/home' },
        { name: 'Pricing', link: '/home#price' },
        { name: 'All Apps', link: '/allapps', tab: false },
        { name: 'Help Center', link: '/help' },
      ],
      nameList: ['/home','/home#price','/allapps', '/help', '/help/detail'],
      dropBoxValue: false,
      timer: '',
      linkName: this.name,
    }
  },
  methods: {
    changeRouter (link) {
      this.$router.push({
        path: link
      }).catch(err => {
        // console.log('e',err)
      })
      // this.linkName = link
    },
    goLink (url) {
      window.open(url)
    },
    dropBoxOut () {
      clearTimeout(this.timer)
      this.timer = setTimeout(()=>{this.dropBoxValue = true}, 300);
    },
    dropBoxIn () {
      clearTimeout(this.timer);
      this.timer = setTimeout(()=>{this.dropBoxValue = false}, 300);
    }
  },
   watch: {
    $route(to, from) {
      //监听路由是否变化
      if(this.$route.hash == "#pricing")
      this.linkName = '/home#price'
      else this.linkName = this.name
        // this.linkName = this.$route.path
    },
  },
}
</script>

<style scoped>
/* .click_for_deails {
  height: 36px;
  background: #fb5821;
  text-align: center;
  font-size: 14px;
  font-family: Helvetica-blod, Helvetica;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
}
.click_for_deails > a {
  font-size: 14px;
  font-family: Helvetica-blod, Helvetica;
  font-weight: bold;
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
} */
.fix_height {
  height: 100px;
}
.header {
  width: 100%;
  background: #fff;
  padding-top: 28px;
  height: 100px;
  position: fixed;
  z-index: 10;
}
.header_black {
  background: linear-gradient(180deg, #10075E 0%, #000000 100%);
}
.header_box {
  width: 1200px;
  margin: 0 auto 0;
  height: 60px;
  position: relative;
}
.header_box > img {
  height: 60px;
  width: 214px;
  cursor: pointer;
}
.logo_right_text::before {
  content: "";
  position: absolute;
  left: -25px;
  top: -2px;
  width: 1px;
  height: 25px;
  background-color: #fff;
}
.logo_right_text {
  position: absolute;
  left: calc(214px + 51px);
  top: 19px;
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  color: #fff;
}
.header_page {
  display: inline-block;
  margin: 0 0 0 454px;
  position: relative;
  vertical-align: middle;
}
.header_text {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  /* font-family: Helvetica-Regular, Helvetica; */
  line-height: 16px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  font-weight: 400;
  color: #0C0546;
}
/* .header_text:hover {
  color: #fc5421;
} */
.header_text_white {
  color: #FFFFFF;
}
.active {
  width: 35px;
  height: 4px;
  background: #01C4C7;
  border-radius: 2px;
  position: absolute;
  bottom: -17px;
  left: -33px;
  transform: translate(-50%, 0);
  transition: all 0.4s;
  opacity: 0;
}
.active0 {
  left: 22px;
  opacity: 1;
}
.active1{
  left: 105px;
  opacity: 1;
}
.active2{
  left: 200px;
  opacity: 1;
}
.active3 {
  left: 309px;
  opacity: 1;
}
.active4 {
  left: 309px;
  opacity: 1;
}
.activ5 {
  left: 113px;
  opacity: 1;
}
.active6 {
  left: 113px;
  opacity: 1;
}
.header_text + .header_text {
  margin-left: 40px;
}
.ad_button {
  float: right;
  margin-top: 6px;
}
.drop_down_box {
  position: fixed;
  z-index: 9999999;
}
.drop_box {
  width: 113px;
  height: 68px;
  margin: 10px 0 0 82px;
  background: #ffffff;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-content: center;
}
.drop_box_1,
.drop_box_2 {
  width: 100%;
  height: 32px;
  padding-left: 12px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 0.65);
  line-height: 32px;
  background: #ffffff;
}
.drop_box_1 {
  margin-top: 2px;
}
.drop_box_1:hover,
.drop_box_2:hover {
  color: #fc5322;
  background: rgba(252, 83, 34, 0.06);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue